<template>
  <div class="m-2">
    <loading-spinner v-if="loading" />
    <template v-else>
      <div>
        <b-row>
          <b-col :cols="2"></b-col>
          <b-col :cols="8" class="text-center">
            <h4 style="color: #49a8e8">
              <strong>{{dashboard.title}}</strong>
            </h4>
            <h6>
              <p v-if="this.last_refreshed"><span style="color: #49a8e8">Last Updated:</span> <strong>{{this.last_refreshed[0]}}<br>({{this.last_refreshed[1]}}</strong></p>
              <p v-if="this.conversion_rate"><span style="color: #49a8e8">Exchange Rate: </span><strong>{{this.conversion_rate}}</strong></p>
              <p v-if="!!this.start_date && !!this.end_date"><span style="color: #49a8e8">Report period:</span> <strong>{{prettifySelectedPeriod(this.start_date, this.end_date)}}</strong></p>
              <p>{{dashboard.description}}</p>
            </h6>
          </b-col>
          <b-col :cols="2"></b-col>
        </b-row>
        <b-row>
          <b-col v-if="this.show_date" :cols="6" :md="8" class="text-left" style="margin-bottom: 10px">
            <h5 v-if="view === 'insights'">Select Date Range</h5>
            <vue-ctk-date-time-picker  v-if="view === 'insights'"
              id="RangeDatePicker"  label="Select a date range" v-model="range_value"
              :custom-shortcuts="custom_shortcuts"
              format="YYYY-MM-DD" :range="true" formatted="ll">
                <b-button variant="primary"
                  class="m-2" size="md">Current Month</b-button>
              </vue-ctk-date-time-picker>
          </b-col>
          <b-col :cols="4" v-if="this.groupNames.length > 1" class="text-right" style="margin-top: 40px; text-transform: uppercase;">
            <b-form-group>
              <b-form-radio-group
                v-model="groupView"
                :options="this.groupNames"
                buttons/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
        </b-row>
      </div>

      <div class="animated fadeIn" v-if="view === 'insights'">
        <b-row>
          <b-col v-for="summary in this.summary_insights" v-if="summary.enabled" :key="summary.sumdata.id" :cols="12" :md="generateSummaryColSize(summary)">
            <b-card-group deck v-if="summary.enabled">
              <b-card class="text-center" header-tag="header" footer-tag="footer">
                <template v-slot:header>
                  <h6 class="mb-0" :id="summary.sumdata.id">{{summary.sumdata.title}}
                  </h6>
                </template>
                <template>
                  <div v-if="typeof summary.sumdata.chart_data.data === 'number'" class="h4 m-0 p-0 text-center">
                    <b-col style="font-size: 35px; color: #20A8D8">{{abbreviateNumber(summary.sumdata.chart_data.data, 1)}}</b-col>
                  </div>
                  <div v-else-if="Array.isArray(summary.sumdata.chart_data.data)" class="h4 m-0 p-0 text-center">
                    <b-row style="font-size: 15px">
                      <b-col v-for="d in summary.sumdata.chart_data.data" :key="d.data + d.unit" style="color: #B0B0B0">
                        {{format_unit(d.unit)}}
                      </b-col>
                    </b-row>
                    <b-row style="font-size: 20px">
                      <b-col v-for="m in summary.sumdata.chart_data.data" :key="m.data + m.unit" style="color: #20A8D8">
                        {{abbreviateNumber(m.data, 1)}}
                      </b-col>
                    </b-row>
                  </div>
                  <div v-else class="h4 m-0 p-0 text-center">
                    <b-col style="font-size: 35px">{{abbreviateNumber(summary.sumdata.chart_data.data, 1)}}</b-col>
                  </div>
                </template>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols :md="12" v-if="this.growth_data != null" style="margin-top: 1rem">
            <b-card-group deck>
              <b-card>
                <growth-chart
                  primary
                  :data="this.growth_data"
                  :percentage="false"
                  :title="`${this.growth_chart_config.title}`"
                  :value-name="`New`"
                  :value-title="growthTitles.value"
                  :aggregation-name="`Cumulative`"
                  :aggregation-title="growthTitles.aggregation" />
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
        <b-row>

<!--          <b-col cols :md="12" v-if="this.map_insights != null" style="margin-top: 1rem">-->
          <b-col cols :md="12" v-for="map_insight in this.map_insights_data" v-if="map_insight.enabled" :key="map_insight.map_data.id" style="margin-top: 1rem">
            <b-card-group deck>
              <b-card>
                <map-chart
                  primary
                  :mapD="map_insight.map_data.data"
                  :title="map_insight.map_data.title"/>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>

        <b-row>
          <!-- <b-col  cols :md="6" :sm="12"> -->
          <b-col cols :md="columnWidth(insight.config.xlabeltype, insight.config.size)" :sm="12" v-for="insight in this.chart_insights" v-if="insight.enabled"
            :key="insight.id">
            <categorical-insight
              :report-id="insight.id"
              :dashboard-id="insight.dashboard_id"
              :dashboard="dashboard"
              :name="insight.title"
              :description="insight.description"
              :subtitle="insight.config.subtitle"
              :values="insight.value"
              :xlabel="insight.config.xlabel"
              :xlabeltype="insight.config.xlabeltype"
              :growthrate="insight.config.growthrate"
              :ylabel="insight.config.ylabel"
              :default-chart="insight.config.default_chart_type"
              :drilldown="insight.config.drill_down"
              :grouped="insight.config.grouped"
              :filter-details="insight.config.filter_details"
              :data-value-label="insight.config.data_value_label"
              :width="4"
              :isString=true>

            </categorical-insight>
          </b-col>
          <br/>
        </b-row>
        <b-row v-if="agent_list.length > 0 && this.groupView === 'List View'">
          <agents-list

            class="mb-2; mt-2"
             action-text="view"
            :enableAction=true
            :enableSort=true
            :enableFilter=true
            :values="agent_list"
            :filter="filter"
            :rowCount="agent_list.length"
            :defaultColumns="defaultCols"
            @act="sendAgentsMail">

          </agents-list>
        </b-row>
      </div>
      <div class="text-center m-5"></div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import {formatMapData, fullURL} from "../../utils";
import { fetchInsight } from "../../utils";
import LoadingSpinner from "../LoadingSpinner";
import CategoricalKeyInsight from "../Insights/CategoricalKeyInsight";
import CategoricalInsight from "../Insights/CategoricalInsight";
import AgentsList from './AgentsList'
import GrowthChart from '../Insights/GrowthChart'
import MapChart from '../Insights/MapChart'
import ListKeyInsight from '../List/ListKeyInsight';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import moment from "moment";
import {round} from "lodash/math";
const parseCategory = (value, type) => {
  if (type === "date") {
    return moment(value).format("MMM DD, YYYY");
  }
  return value;
};

export default {
  name: "AgentsReports",
  components: {
    LoadingSpinner,
    CategoricalKeyInsight,
    ListKeyInsight,
    CategoricalInsight,
    AgentsList,
    GrowthChart,
    MapChart,
    VueCtkDateTimePicker
  },
  props: {
    dashboard: Object
  },
  data() {
    const {view} = this.$route.query;
    const dashboards = this.$store.state.files.dashboards;
    const user_data = this.$store.state.general.user;
    const currency = this.$store.state.general.currency;
    return {
      range_value:null,
      custom_shortcuts: [
          {
            key: 'alltime',
            label: 'All Time',
            value: () => {
              return {
                start: moment(this.dashboard.start_date),
                end: moment().startOf('day').add(1, 'days')
              }
            }
          }, {
            key: 'today',
            label: 'Today',
            value: () => {
              return {
                start: moment().startOf('day'),
                end: moment().startOf('day').add(1, 'days')
              }
            }
          },
          { key: 'thisWeek', label: 'This week', value: 'isoWeek' },
          {key: 'lastWeek', label: 'Last week', value: '-isoWeek'},
          {key: 'last7Days', label: 'Last 7 days', value: 7},
          {key: 'last30Days', label: 'Last 30 days', value: 30},
          {key: 'thisMonth', label: 'This month', value: 'month'},
          {key: 'lastMonth', label: 'Last month', value: '-month'},
          {key: 'thisYear', label: 'This year', value: 'year'},
          {key: 'lastYear', label: 'Last year', value: '-year'}
        ],
      view: view === "list" ? view : 'insights',
      count: null,
      chart_data: null,
      chart_description: null,
      loading: true,
      summary_insights:[],
      chart_insights: [],
      map_insights: null,
      growth_chart_config: null,
      report_ids:[],
      dashboards:dashboards,
      user_data: user_data,
      currency: currency,
      show_date: true,
      group_name_col: 4,
      growth_data: null,
      growth_charts: [],
      map_insights_data: [],
      start_date: null,
      end_date: null,
      // options: [
      //     { value: null, text: 'All Agents' }],
      selected: -1,
      defaultCols: [],
      list_view_insights: [],
      agent_list: [],
      groups: [],
      // groupNames: [{text: "ALL", value: "all"}],
      groupNames: [],
      // groupView: "all",
      groupView: null,
      filter: {
          method: "dynamic",
          values: {
            logic: "and",
            filters: []
          }
        },
      conversion_rate: null,
      last_refreshed: null,
      currency_placeholder: "currency_placeholder",
      currency_symbol_placeholder: "currency_symbol_holder"
    };
  },

  created() {
    axios.get(
      fullURL(`/dashboards/additional_config/conversion_rate`)
    ).then(({data}) => {
        this.conversion_rate = data["value"];
      }
    )
    console.log("dashboard", this.dashboard)
    if (this.dashboard.id === "605b1acb54d4f48bf60175ec") {
      axios.get(
      fullURL(`/custom-reports/agents`)
    ).then(({data}) => {
        this.agent_list = data["data"]
        this.defaultCols = data["defaultColumns"]
      }
    )
    }
      if (this.dashboard.report_ids.length > 0) {
        const request_data = "?dashboard_id="+this.dashboard.id

        this.dashboard.report_ids.forEach(id=> {
            axios.get(
          fullURL(
              `/dashboards/report/${id.report_id}` + request_data
            )
        ).then(({data}) =>{
            this.processChartData(data, id, this.dashboard.id)
        }).catch(console.log)
          .finally(() => {
            this.loading = false;
          })
        })
      }
    },

  watch:{
    range_value(val) {
      const {start, end} = val;
      if (start != null && end != null) {
        this.start_date = start;
        this.end_date = end;
        this.reloadData()

      } else {
        console.log("something is not complete")
      }
    },

    selected(val){
      this.reloadData()
    },

    groupView(val) {
      if (val === "all") {
        this.summary_insights.forEach(summary => {
          summary["enabled"] = true
        })
        this.chart_insights.forEach(chart => {
          chart["enabled"] = true
        })
        this.growth_chart_config = null
        this.growth_data = null
        this.growth_charts.forEach(growth_chart => {
          // if (growth_chart["group_name"] === val) {
            this.growth_chart_config = growth_chart["growth_data"];
            this.growth_data = growth_chart["growth_data"].chart_data.data;
          // }
        })
        this.map_insights = null
        this.map_insights_data.forEach(map_chart => {
          map_chart["enabled"] = true
        })

      } else {
        this.summary_insights.forEach(summary => {
          summary["enabled"] = summary["group_name"] === val;
        })
        this.chart_insights.forEach(chart => {
          chart["enabled"] = chart["group_name"] === val;
        })
        this.growth_chart_config = null
        this.growth_data = null
        this.growth_charts.forEach(growth_chart => {
          if (growth_chart["group_name"] === val) {
            this.growth_chart_config = growth_chart["growth_data"];
            this.growth_data = growth_chart["growth_data"].chart_data.data;
          }
        })
        this.map_insights = null
        this.map_insights_data.forEach(map_chart => {
            map_chart["enabled"] = map_chart["group_name"] === val;
        })
      }
    }

  },

  computed:{
    getTitle() {
      return this.name;
    },

    modalDescID(title) {
      return "modal-description-" + title;
    },

    options(){
      let result = [{text: "All Agents", value: -1}]
      let a = this.list_view_insights.map(({_id, name, phoneNumber}) => ({text:name, value:phoneNumber}));
      result = result.concat(a)
      return result
    },

    growthTypeOptions() {
      return [
        {value: 'count', text: 'Total Count'},
        {value: 'amount', text: 'Total Amount'},
        {value: 'average', text: 'Average Amount'},
        {value: 'percent_count', text: 'Count %'},
        {value: 'percent_amount', text: 'Amount %'},
      ];
    },

    growthType() {
      // if (this.growthTypeIsPercentage) {
      //   return this.growthTypeKey.substr('percent_'.length);
      // }
      // return this.growthTypeKey;
      return 'count';
    },

    growthTitles() {
      const suffix = ''; // this.growthTypeIsPercentage ? ' (%)' : '';
      const name = ((growthType) => {
        switch (growthType) {
          case 'average':
            return 'Average Amount';
          case 'amount':
            return 'Amount';
          default:
            return 'Count';
        }
      })(this.growthType);

      return {
        value: `New ${name} ${suffix}`,
        aggregation: `Total ${name} ${suffix}`
      };
    }
  },

  methods: {
    collection_name() {
      return 'agents';
    },

    columnWidth(xlabelType, size) {
      if (size > 1) {
        return 6*size
      }
      return (!!xlabelType && xlabelType !== 'string') ? 6 : 6;
    },

    sendAgentsMail(record){
      const record_id = record["phoneNumber"];
      const confirmed_email =  record["confirmed_email"]
      const today = new Date();
      const start = new Date(today.getFullYear(), 0, 1, 1).toISOString().slice(0, 10);
      const end_date = new Date(today.getFullYear(), today.getMonth() + 1, 1, 1);
      end_date.setDate(end_date.getDate() - 1);
      const end = end_date.toISOString().slice(0, 10);
      const current_month = today.getMonth() + 1;
      const current_year = today.getFullYear()
      axios({
      method: 'post',
      url: fullURL('/custom-reports/agent-report/summary/email'),
      data: {
          "email": confirmed_email,
          "year": today.getFullYear(),
          "month": today.getMonth() + 1,
          "customer_id": record_id},

      }
      ).then(
          ({data}) =>{
              console.log("Email Sent")

          }
      );
        // this.$router.push(`/custom-reports/agent-report/summary/${record_id}`);
    },

    reloadData() {
      let date_range = this.range_value;
      let selected_agent = this.selected;

      let start_date = null;
      let end_date = null;

      if (date_range != null) {
        start_date = date_range.start
        end_date = date_range.end
      }

      let request_data = "?dashboard_id="+this.dashboard.id + "&"
      if (start_date != null && end_date != null) {
        request_data += "start_date="+start_date+"&end_date="+end_date
      }
      if (selected_agent != null && selected_agent > -1) {
        request_data+= "&agent_id="+selected_agent
      }

      this.summary_insights = [];
      this.chart_insights = [];
      this.dashboard.report_ids.forEach(id=>
        axios.get(
        fullURL(`/dashboards/report/${id.report_id}` + request_data)
      ).then(({data}) =>{
        this.processChartData(data, id, this.dashboard.id)
      }).catch(console.log)
        .finally(() => {
          this.loading = false;
        })
      );
    },

    abbreviateNumber(number, precision) {
      var SI_SYMBOL = ["", "k", "M", "B", "T", "P", "E"];
      var tier = Math.log10(number) / 3 | 0;
      if(tier == 0) {
        if (number % 1 !== 0) {
          return round(number, precision)
        }
        return number;
      }
      var suffix = SI_SYMBOL[tier];
      var scale = Math.pow(10, tier * 3);
      var scaled = number / scale;
      return scaled.toFixed(1) + suffix;
    },

    format_unit(unit) {
      unit = unit.replace(this.currency_placeholder, this.currency.currency_name)
      unit = unit.replace(this.currency_symbol_placeholder, this.currency.currency_symbol)
      return unit
    },

    formatDateText(month_year, datatype) {
      if (datatype && datatype.toLowerCase() !== "date") {
        return month_year
      }
      let month_names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      let month_names_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      if (month_year && month_year.includes("-")) {
        let res = month_year.split("-");
        return month_names[res[1] - 1] + " " + res[2] + " " + res[0];
      }
      else if (month_year && month_year.includes("/")) {
        let res = month_year.split("/");
        return month_names_short[res[0] - 1] + " " + res[1];
      }
      return month_year
    },

    sortByMonthYearDate(a,b) {
      a = a["_id"]
      b = b["_id"]
      var as = a.split('/'),
          bs = b.split('/'),
          ad = new Date(as[0]+' 1,'+as[1]),
          bd = new Date(bs[0]+' 1,'+bs[1]);
      return ad.getTime() - bd.getTime();
    },

    prettifySelectedPeriod(start_date, end_date) {
      const today = moment();
      const start = moment(start_date, "YYYY-MM-DD");
      const end = moment(end_date, "YYYY-MM-DD");
      const next_end = moment(end_date, "YYYY-MM-DD").add(1, "days");
      let diff = start.diff(end, "days");
      if ((start.date() == 1) && (start.month() == 0) && (end.month() == 11) && (next_end.date() == 1)) {
        return start.format("YYYY");
      }
      else if ((start.date() == 1) && (next_end.date() == 1) && (end.month() == start.month())) {
        return start.format("MMMM, YYYY");
      }
      else if (end.diff(start, "days") == 6) {
        if ((start < today) && (today < end)) {
          return "This Week";
        }
        else if ((end < today) && (today.diff(end, "days") < 7)) {
          return "Last Week";
        }
      }
      else if ((end.diff(start, "days") < 31) && (end.month() == today.month()) && (end.date() == today.date())) {
        return "The Last " + end.diff(start, "days") + " Days";
      }
      else {
        return start_date + " - " + end_date;
      }
    },

    generateSummaryColSize(summary) {
      if ("group_report_ids" in summary.sumdata) {
        if (summary.sumdata.group_report_ids.length >= 4) {
          return 6
        }
      }
      let length = this.summary_insights.filter((x,i) => { return x.enabled; }).length
      if ( length <= 2) {
        return 6
      } else if ([3, 5, 6, 9].includes(length)){
        return 4
      } else if ([4, 7, 8, 10, 11, 12].includes(length) ){
        return 3
      } else {
        return 2
      }
    },

    // formatMapData(data) {
    //   let state_codes = {"rivers": 'ng-ri', "katsina": 'ng-kt', "sokoto": 'ng-so', "zamfara": 'ng-za', "yobe": 'ng-yo', "kebbi": 'ng-ke', "adamawa": 'ng-ad', "borno": 'ng-bo', "akwa ibom": 'ng-ak', 'abia': 'ng-ab', "imo": 'ng-im', "bayelsa": 'ng-by', "benue": 'ng-be', "cross river": 'ng-cr', "taraba": 'ng-ta', "kwara": 'ng-kw', "lagos": 'ng-la', "niger": 'ng-ni', "federal capital territory": 'ng-fc', "ogun": 'ng-og', "ondo": 'ng-on', "ekiti": 'ng-ek', "osun": 'ng-os', "oyo": 'ng-oy', "anambra": 'ng-an', "bauchi": 'ng-ba', "gombe": 'ng-go', "delta": 'ng-de', "edo": 'ng-ed', "enugu":'ng-en', "ebonyi": 'ng-eb', "kaduna": 'ng-kd',  "kogi": 'ng-ko', "plateau": 'ng-pl', "nasarawa": 'ng-na', "jigawa": 'ng-ji', "kano": 'ng-kn'}
    //   data.forEach( d => {
    //     d[0] = state_codes[d[0].toLowerCase()]
    //   })
    //
    //   return data
    // },

    processChartData(data, id, dashboard_id=null) {
      let report_id = id.report_id;
      let position = id.position;
      let group_name = id.group_name;

      if (group_name) {
        if (this.groupView === null) {
          this.groupView = group_name
        }
        if (group_name in this.groups) {
          this.groups[group_name].push(report_id)
        } else {
          this.groups[group_name] = [report_id]
          this.groupNames.push({text: group_name.toUpperCase(), value: group_name})
        }
      }
      let enabled = true
      if (this.groupView !== null) {
        enabled = this.groupView === group_name
      }
      if (!this.last_refreshed) {
        if ("refresh_date" in data.chart_data && data.chart_data["refresh_date"]) {
          let refresh_date = data.chart_data["refresh_date"]
          let stringDate = new Date(refresh_date + " UTC").toString().split('(')
          this.last_refreshed = stringDate
        }
      }
      data.title = data.title.replace(this.currency_placeholder, this.currency.currency_name)
      data.title = data.title.replace(this.currency_symbol_placeholder, this.currency.currency_symbol)
      data.description = data.description.replace(this.currency_placeholder, this.currency.currency_name)
      data.description = data.description.replace(this.currency_symbol_placeholder, this.currency.currency_symbol)
      data.chart_config.xlabel = data.chart_config.xlabel.replace(this.currency_placeholder, this.currency.currency_name)
      data.chart_config.xlabel = data.chart_config.xlabel.replace(this.currency_symbol_placeholder, this.currency.currency_symbol)
      data.chart_config.ylabel = data.chart_config.ylabel.replace(this.currency_placeholder, this.currency.currency_name)
      data.chart_config.ylabel = data.chart_config.ylabel.replace(this.currency_symbol_placeholder, this.currency.currency_symbol)
      if (data.report_type === 'summary') {
        this.summary_insights.push({"id": report_id, "position": position, "group_name": group_name, "sumdata": data, "enabled": enabled, "dashboard_id": dashboard_id});
        this.summary_insights.sort(function (a, b) {
          return a.position - b.position;
        })
      } else if (data.report_type === 'growth_chart') {
        this.growth_charts.push({"group_name": group_name, "growth_data": data})
        if (group_name == null) {
          this.growth_chart_config = data;
          this.growth_data = data.chart_data.data;
        } else {
          if (group_name === this.groupView) {
            this.growth_chart_config = data;
            this.growth_data = data.chart_data.data;
          }
        }

      } else if (data.report_type === 'chart') {
        if (data.chart_config.default_chart_type === "stacked_column") {
          this.chart_insights.push({
            "id": report_id,
            "dashboard_id": dashboard_id,
            "position": position,
            "title": data.title,
            "description": data.description,
            "config": data.chart_config,
            "value": data.chart_data.data,
            "group_name": group_name,
            "enabled": enabled
          });
        }
        else if (data.chart_config.default_chart_type === "heat_map") {
          this.chart_insights.push({
            "id": report_id,
            "dashboard_id": dashboard_id,
            "position": position,
            "title": data.title,
            "description": data.description,
            "config": data.chart_config,
            "value": data.chart_data.data,
            "group_name": group_name,
            "enabled": enabled
          });
        }
        else if (data.chart_config.drill_down && data.chart_config.subtitle) {
          this.chart_insights.push({
            "id": report_id,
            "dashboard_id": dashboard_id,
            "position": position,
            "title": data.title,
            "description": data.description,
            "config": data.chart_config,
            "value": data.chart_data.data,
            "group_name": group_name,
            "enabled": enabled
          });
        } else if (data.chart_config.grouped) {
          for (let d = 0; d < data.chart_data.data.categories.length; d++) {
            data.chart_data.data.categories[d] = this.formatDateText(data.chart_data.data.categories[d], data.chart_config.xlabeltype)
          }
          this.chart_insights.push({
            "id": report_id,
            "dashboard_id": dashboard_id,
            "position": position,
            "title": data.title,
            "description": data.description,
            "config": data.chart_config,
            "value": data.chart_data.data,
            "group_name": group_name,
            "enabled": enabled
          });
        } else {
          if (data.chart_config.xlabeltype && data.chart_config.xlabeltype.toLowerCase() === "date") {
            data.chart_data.data.sort(this.sortByMonthYearDate)
          }
          this.chart_insights.push({
            "id": report_id,
            "dashboard_id": dashboard_id,
            "position": position,
            "title": data.title,
            "description": data.description,
            "config": data.chart_config,
            "value": data.chart_data.data.map(e => ([this.formatDateText(e['_id'], data.chart_config.xlabeltype), round(e['count'])])),
            "group_name": group_name,
            "enabled": enabled
          });
        }
        this.chart_insights.sort(function (a, b) {
          return a.position - b.position;
        })
      } else if (data.report_type === 'map') {
        let map_data = data.chart_data.data
        let map_insight = {}
        map_insight.data = formatMapData(map_data);
        map_insight.title = data.title;
        map_insight.dashboard_id = dashboard_id;
        map_insight.id = report_id;
        this.map_insights_data.push({"group_name": group_name, "map_data": map_insight, "enabled": enabled})

      }
    }
  }
};
</script>

<style scoped>
</style>
